import React, { Component } from 'react'
//import activity from 'nw-activity'

import PopupAlerteVeille from './PopupAlerteVeille';


class TempoVeille extends Component {

  state = {
    popup_alerte: false
  }

  componentDidMount() {
    this._startTempoVeille();
  }

  componentWillUnmount() {
    this._resetTempoVeille();
  }

  render() {

    const { tempo_alerte_veille } = this.props;
    const { popup_alerte } = this.state;

    let result = popup_alerte && <PopupAlerteVeille duree_affichage={tempo_alerte_veille}/>;
    return result;
  }

  _startTempoVeille = () => {

    const { tempo_veille, tempo_alerte_veille, onVeille } = this.props;

    this.props.logFn("TempoVeille::_startTempoVeille() : " + tempo_veille +"s");

    mgtimer.stop(); // au cas ou deja démarrée
    mgtimer.start(tempo_veille*1000, ()=>{
      onVeille()
    })
    mgtimer.show_alert(tempo_alerte_veille*1000, ()=>{
      this.setState({popup_alerte: true})
    })
  }

  _resetTempoVeille = () => {
    mgtimer.reset()
    this.setState({popup_alerte: false})
  }

}


 /* ---- */

 const mgtimer =
 {

    start_time: null,
    tempo_interval: null,
    tempo_alert: null,
    alert_callback: null,

    start: function(tempo, time_out_callback){

        //console.log("## mgtimer:start:"+tempo)

        this.start_time = performance.now()
        var self = this;
        function checkTime(){
            var now = performance.now()
            if (self.start_time + tempo < now ){
                self.stop()
                //console.log("## mgtimer::time_out_callback()");            
                time_out_callback()
            }

            if (self.tempo_alert) {
                if (self.start_time + tempo -  self.tempo_alert <= now) {
                    //console.log("## mgtimer::alert_callback()");            
                    self.alert_callback()
                }
            }
        }

        this.tempo_interval = window.setInterval(checkTime, 1000)
    },


    stop: function(){

        //console.log("## mgtimer:stop");

        window.clearInterval(this.tempo_interval)
        this.tempo_interval = null

        this.start_time = null
        this.tempo_alert = null
        this.alert_callback = null
    },

    reset: function(){
        //console.log("## mgtimer:reset");

        this.start_time = performance.now()
    },

    show_alert: function(tempoalert, alert_callback){

        //console.log("## mgtimer:show_alert:"+tempoalert);

        this.tempo_alert = tempoalert
        this.alert_callback = alert_callback
    }

}



export default TempoVeille;


// WEBPACK FOOTER //
// ./src/TempoVeille.js